import carregar from '../../img/carregar.gif'

import './styles/carregar-pagina.css'

function CarregarPagina() {
    return (
        <div className="carregar-pagina">
            <img src={carregar} alt="" />
        </div>
    )
}

export default CarregarPagina